import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTab = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30 28H16L10 20L16 12H30V28Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgTab);
export default ForwardRef;
